import { trigger_interaction } from './Analytics';
export function selectionTableLocation({ locationAbbr }) {
    trigger_interaction('TABLE', 'o', `LOCATION, ${locationAbbr}`);
}
export function selectTableSubQuestion({ questionId, subQuestionId }) {
    trigger_interaction('TABLE', 'o', `SUBQ, ${questionId}, ${subQuestionId}`);
}
export function selectTableReturn() {
    trigger_interaction('TABLE', 'o', 'Return');
}